// Stub for websocket store - replace with actual implementation
export const useWebSocketStore = () => ({
  isConnected: false,
  connect: () => {},
  disconnect: () => {},
  subscribe: (_key: string, _channel: string, _options?: any) => () => {}, // Updated signature
  unsubscribe: (_key: string, _channel: string, _options?: any) => {},
  createConnection: (_key: string, _path: string, _options?: any) => {},
  removeConnection: (_key: string) => {},
  addMessageHandler: (_key: string, _handler: (message: any) => void, _filter?: (message: any) => boolean) => {},
  removeMessageHandler: (_key: string, _handler: (message: any) => void) => {},
  isConnectionOpen: (_key: string) => false,
});
